import {
  QueryFunction,
  QueryKey,
  useQuery,
  UseQueryOptions,
} from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { DashBoardApiService } from 'features/Dashboard/api/dashboard-api.service';
import { User } from 'types';

import { DashboardQueryKeys } from './query-keys';
// ../api/dashboard-api.service

const { getLegalDocuments } = DashBoardApiService();

const getUserQuery = (
  id: string,
  options?: UseQueryOptions<User>,
): {
  queryKey: QueryKey;
  queryFn: QueryFunction<User>;
  options?: UseQueryOptions<User>;
} => ({
  queryKey: DashboardQueryKeys.detail(id),
  queryFn: ({ signal }) => getLegalDocuments(id, { config: { signal } }),
  ...options,
});

export const useGetLegalDashBaordList = (
  id: string,
  options?: UseQueryOptions<any>,
) => {
  const { message } = App.useApp();

  return useQuery<any, Error>(
    getUserQuery(id, {
      onError: (error: unknown) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      ...options,
    }),
  );
};
